import { render, staticRenderFns } from "./AboutInviteCodes.vue?vue&type=template&id=33fb924b&scoped=true&"
import script from "./AboutInviteCodes.vue?vue&type=script&lang=js&"
export * from "./AboutInviteCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fb924b",
  null
  
)

export default component.exports